export const canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

export function findAncestor (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls)); // eslint-disable-line no-cond-assign
    return el;
}


// WEBPACK FOOTER //
// ./src/utils/dom.js